import {
  type NavigationClickData,
  navigationClickToDataLayer,
} from "@/utils/gtm.utils";

// Segments Contentful prefixes to Internal Names to mark the entry type.
const TYPE_SEGMENTS = new Set([
  "item",
  "column",
  "link item",
  "sub item",
  "navigation item",
  "navigation link item",
  "navigation column",
]);
const INTERNAL_HOSTNAME = "scott-sports.com";

/** "Item › Bike › Bikes" becomes "bike > bikes". */
export function toNavigationContentId(internalName: string): string {
  return internalName
    .split("›")
    .map((segment) => segment.trim().toLowerCase())
    .filter((segment) => segment && !TYPE_SEGMENTS.has(segment))
    .join(" > ");
}

export function getNavigationLinkType(
  url: URL,
  currentOrigin: string
): "internal" | "external" {
  const isScottHost =
    url.hostname === INTERNAL_HOSTNAME ||
    url.hostname.endsWith(`.${INTERNAL_HOSTNAME}`);
  return isScottHost || url.origin === currentOrigin ? "internal" : "external";
}

function getNavType(element: Element): NavigationClickData["navType"] {
  const context = element
    .closest("[data-nav-context]")
    ?.getAttribute("data-nav-context");
  if (context === "mega_menu" || context === "mobile_menu") {
    return context;
  }
  return element.closest("footer") ? "footer" : "header";
}

/** Reads the tracking attributes of the clicked menu entry and pushes the event. */
export function trackNavigationClick(target: EventTarget | null) {
  if (!(target instanceof Element)) {
    return;
  }
  const element = target.closest("[data-nav-name]");
  const internalName = element?.getAttribute("data-nav-name");
  if (!(element && internalName)) {
    return;
  }

  const href = element.getAttribute("href");
  let url: URL | undefined;
  if (href) {
    try {
      url = new URL(href, window.location.origin);
    } catch {
      url = undefined;
    }
  }

  navigationClickToDataLayer({
    contentId: toNavigationContentId(internalName),
    navType: getNavType(element),
    navLevel: Number(element.getAttribute("data-nav-level")),
    navIndex: Number(element.getAttribute("data-nav-index")),
    navText: element.textContent?.trim() ?? "",
    linkType: url
      ? getNavigationLinkType(url, window.location.origin)
      : undefined,
    linkUrl: url?.href,
  });
}
